import { render, staticRenderFns } from "./CecAboutList.vue?vue&type=template&id=624c210e"
import script from "./CecAboutList.vue?vue&type=script&lang=js"
export * from "./CecAboutList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('624c210e')) {
      api.createRecord('624c210e', component.options)
    } else {
      api.reload('624c210e', component.options)
    }
    module.hot.accept("./CecAboutList.vue?vue&type=template&id=624c210e", function () {
      api.rerender('624c210e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/about/CecAboutList.vue"
export default component.exports